export default __webpack_public_path__ + "static/media/like-icon.df17c83f.svg";